"use client";

import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { ContentfulImage } from "../../components/ContentfulImage";

import type { ContentTeamMember } from "../content";

type Props = {
  teamMembers: ContentTeamMember[];
};

export function PageComponent(props: Props): ReactNode {
  return (
    <>
      <Heading>Unser Team</Heading>
      <Flex
        flexWrap={["nowrap", "nowrap", "wrap"]}
        flexDirection={["column", "column", "row"]}
        mt={4}
      >
        {props.teamMembers.map((teamMember) => (
          <Box
            key={teamMember.id}
            borderWidth="1px"
            rounded="lg"
            boxShadow="md"
            overflow="hidden"
            mb={[8]}
            mx="auto"
          >
            <ContentfulImage
              src={teamMember.imageUrl}
              alt={teamMember.name}
              height={425}
              width={283}
            />
            <Box p={4}>
              <Heading as="h3" fontSize="lg" textAlign="center">
                {teamMember.name}
              </Heading>
              <Text textAlign="center">{teamMember.level}</Text>
            </Box>
          </Box>
        ))}
      </Flex>
    </>
  );
}
